// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { externalLinkOpen } from '../../actions/externallink';
import { doLoginEmbedded as doLoginEmbeddedAction } from '../../actions/login';
import useMergeProps from '../../hooks/useMergeProps';
import { type Licence } from '../../types/common';

import MobileLayout from './MobileLayout';
import selectMobileLayoutProps from './MobileLayout.selector';

type MobileLayoutContainerProps = {
  className?: string;
};
const MobileLayoutContainer = (ownProps: MobileLayoutContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectMobileLayoutProps);

  const openExternalLink = useCallback(
    (url, options) => {
      dispatch(externalLinkOpen(url, options));
    },
    [dispatch],
  );

  const doLoginEmbedded = useCallback(
    (data: { licence: Licence; onLoginDismissed: () => void }) => {
      dispatch(doLoginEmbeddedAction(data));
    },
    [dispatch],
  );

  const otherProps = useMemo(() => ({ doLoginEmbedded, openExternalLink }), [doLoginEmbedded, openExternalLink]);

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <MobileLayout {...enhancedProps} />;
};

export default MobileLayoutContainer;
